const Cancel = ({ width = 30, height = 30 }) => (
  <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
    <g fill="#2A3135" fillRule="nonzero">
      <path d="M14.965 0C6.7 0 0 6.7 0 14.965s6.7 14.966 14.965 14.966 14.966-6.7 14.966-14.966C29.93 6.7 23.23 0 14.965 0zm0 28.06c-7.232 0-13.094-5.863-13.094-13.095S7.733 1.871 14.965 1.871c7.232 0 13.095 5.862 13.095 13.094A13.095 13.095 0 0114.965 28.06z" />
      <path d="M13.778 20.108a1.87 1.87 0 01-1.347-.57L9.43 16.441a.936.936 0 011.347-1.3l3.002 3.095 5.612-7.118a.953.953 0 011.506 1.17l-5.612 7.118a1.87 1.87 0 01-1.375.701h-.13z" />
    </g>
  </svg>
);

export default Cancel;
